// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1KWeW","grow0":"Button_grow0__34R0B","grow1":"Button_grow1__1s4Pi"};